import * as IMAGE from '../../lib/image/event/EventChristmasImages';
import * as PATH from '../../lib/routes/path';

export const ID_CHRISTMAS = 'christmas';
export const PERIOD_CHRISTMAS = {
  startDate: '2024-12-01T00:00:00',
  endDate: '2024-12-30T23:59:59',
};

export const EVENT_HOME_BANNER_CHRISTMAS = {
  id: ID_CHRISTMAS,
  period: PERIOD_CHRISTMAS,
  image: IMAGE.HOME_BANNER_CHRISTMAS,
  path: PATH.SALES,
};
